import React from 'react';
import { FaPlus } from 'react-icons/fa';
import '../styles/Projects.css';

const ProjectCategories = () => {
  const cats = ['Residential','Commercial','Industrial','Solar Systems','Security Systems'];
  return (
    <div className="projects-page">
      <h1>Project Categories</h1>
      <p>Manage categories for your projects.</p>
      <button className="add-btn"><FaPlus /> Add Category</button>
      <table className="projects-table">
        <thead><tr><th>#</th><th>Category</th><th>Projects</th><th>Actions</th></tr></thead>
        <tbody>{cats.map((c,i)=>(<tr key={i}><td>{i+1}</td><td>{c}</td><td>{Math.floor(Math.random()*5)+1}</td><td><button className="edit-btn">Edit</button> <button className="delete-btn">Delete</button></td></tr>))}</tbody>
      </table>
    </div>
  );
};
export default ProjectCategories;
